<script lang="ts" setup>
const emit = defineEmits(["select"]);

// -----------------------
// composables
// -----------------------
const config = useRuntimeConfig();
const { t } = useI18n();

// -----------------------
// refs
// -----------------------
const searchTerm = ref("");
const isOpen = ref(false);
const hits = ref([]);

// -----------------------
// methods
// -----------------------
const setSelected = (item) => {
  isOpen.value = false;
  searchTerm.value = "";
  emit("select", item);
};

// -----------------------
// vue events
// -----------------------
watch(
  () => searchTerm.value,
  async () => {
    if (searchTerm.value) {
      hits.value = await useMeilisearch(
        config.public.meilisearchIndexAddresses,
        {
          q: searchTerm.value,
          limit: 50,
          attributesToSearchOn: ["name"],
        },
      );
      if (hits.value.length > 0) isOpen.value = true;
    } else {
      hits.value = [];
      isOpen.value = false;
    }
  },
);
</script>

<template>
  <div class="relative">
    <BaseInput v-model="searchTerm" :title="t('search_address')" />
    <div class="text-xs text-gray-500">{{ t("search_address_hint") }}</div>
    <div v-if="isOpen" class="w-full absolute z-10 rounded px-1 top-[42px]">
      <ul
        class="w-full max-h-60 bg-white overflow-y-auto unstyled border border-grey-300"
      >
        <li
          v-for="hit in hits"
          :key="hit.id"
          class="cursor-pointer"
          @click="setSelected(hit)"
        >
          {{ hit.name }}
        </li>
      </ul>
    </div>
  </div>
</template>
